export default function CardGroup({ children }) {
  return (
    <div className='pl-8 grid gap-4 grid-flow-col-dense grid-cols-5 w-full mb-24'>
      {children}
    </div>
  )
}
